import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Guide14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_101)'>
      <path
        d='M6.00006 9.56065L10.0304 5.53032L8.96973 4.46966L6.00006 7.43933L4.53039 5.96966L3.46973 7.03032L6.00006 9.56065Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.1819 0.772335C0.716035 0.655869 0.25 1.01974 0.25 1.49994V10.9999C0.25 11.3441 0.484223 11.6441 0.818098 11.7275L6.8181 13.2275C6.93753 13.2574 7.06247 13.2574 7.1819 13.2275L13.1819 11.7275C13.5158 11.6441 13.75 11.3441 13.75 10.9999V1.49994C13.75 1.01974 13.284 0.655869 12.8181 0.772335L7 2.22686L1.1819 0.772335ZM1.75 10.4144V2.46052L6.8181 3.72755C6.93753 3.75741 7.06247 3.75741 7.1819 3.72755L12.25 2.46052V10.4144L7 11.7269L1.75 10.4144Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_101'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Guide14.displayName = 'Guide14';
export default Guide14;
